/*
 * @Description: 自然人
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { agentManager } from '@/api/ajax';
import fields, { createDownloadName } from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });
let part = example.createPart({
  name: '自然人',
  search: [
    'projectName',
    'userName',
    'phone',
    'industryEnterpriseId',
    'userTag',
    'authStatus',
    'isComplete',
    'settledStatus',
    'agentStatus',
    'estimateSettlementTime'
  ],
  list: agentManager.agentList,
  defaultQueryHotfix: { userType: 1 },
  fields: [
    'index',
    'fullName',
    'phone',
    'realNameStatus',
    'occupationAuthStatus',
    'userTag',
    'createDt',
    'historyProject',
    'submitNum',
    'taskSumSurplus',
    'passingTaskSumPlatform',
    'passTaskSumPlatform',
    'passingTaskSum',
    'noFinishTaskSum',
    'taskSumNoFinishPrice',
    'userAmount',
    'prePurchaseProsces',
    'projectSet'
  ],
  moreBtnArr: [createDownloadName({ userType: 1 })]
});

export default part;
